<template>
    <div class="bto-sb-widget bto-sb-widget-main-nav" :class="{'bto-sb-widget-pills-nav' : useScrollMenu}">
        <div class="bto-sb-widget-content">
            <div  :class="{'bto-sb-scrolling-menu' : useScrollMenu, 'bto-sb-main-nav-left':  !useScrollMenu}">
                <ul>
                    <li v-for="(l, index) in links"
                        :key="index"
                        :class="{
                'bto-sb-main-nav-active' : index === selectedLinkIndex}"
                    >
                      <component :is="l.component" v-bind="l.props">{{t(l.label)}}
                        <span class="bto-sb-badge"
                         v-if="l.label == 'Mobile.LiveNow' && liveMatchesCount > 0">
                          {{ liveMatchesCount }}
                        </span>
                      </component>
                    </li>
                </ul>
            </div>
            <div class="bto-sb-main-nav-right">
                <div class="bto-sb-form-select" v-if="false">
                    <select v-model="selectedTimezone" @change="selectTimezone($event)">
                        <option value="-3">{{getCurrentTime(-3)}}</option>
                        <option value="-2">{{getCurrentTime(-2)}}</option>
                        <option value="-1">{{getCurrentTime(-1)}}</option>
                        <option value="0">{{getCurrentTime(null)}}</option>
                        <option value="1">{{getCurrentTime(1)}}</option>
                        <option value="2">{{getCurrentTime(2)}}</option>
                        <option value="3">{{getCurrentTime(3)}}</option>
                    </select>
                    <div class="bto-sb-form-select-arrow"></div>
                </div>
                <div class="bto-sb-form-select" v-if="useOddFormatSelector">
                    <select v-model="oddFormat" @change="selectOddFormat($event)">
                        <option value="decimal">{{t('Public.Decimal')}}</option>
                        <option value="fractional">{{t('Public.Fractional')}}</option>
                        <option value="american">{{t('Public.American')}}</option>
                    </select>
                    <div class="bto-sb-form-select-arrow"></div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
  import store from '../../../store';
  import { EventBus } from '../../../services/event-bus-service';
  import { getLinkProps } from '@bto-services/quick-links';
  import { userLoggedIn } from '@bto-services/user';
  import { LiveWorker } from "../../../workers";

  export default {
    name: 'MainNavWidget',
    data() {
      return {
        oddFormat: '',
        // now: new Date(),
        // clock: undefined,
        // selectedTimezone: '',
        selectedLinkIndex: 0,
        liveMatches: {},
      };
    },
    props: {
      navlinks: {
        fieldType: 'link-repeater',
        label: 'Add Links',
        default: () => [
          {
            applied: true,
            editmode: false,
            label: 'Link1',
            link: '#',
          },
          {
            applied: true,
            editmode: false,
            label: 'Link2',
            link: '#',
          },
        ],
      },
      useOddFormatSelector: {
        fieldType: 'Boolean',
        default: true,
        label: 'show oddFormat selector'
      },
      useDefaultLayoutLinks: {
        type: Boolean,
        fieldType: 'Boolean',
        default: false,
        label: 'Use Links from default layout',
        description: 'Flag weather we should overwrite navlinks with links from default layout'
      },
      useScrollMenu: {
        type: Boolean,
        default: false,
        label: 'Use scroll menu',
      },
    },
    computed: {
      compNavLinks() {
        const defaultWidget = store.getters.getDefaultLayoutWidget('main-nav-widget');
        return this.useDefaultLayoutLinks && defaultWidget ? defaultWidget.compiledProps.navlinks : this.navlinks;
      },
     links() {
        const isRestrictedPath = path => /^\/(mybets)(\/|$)/.test(path);
        return this.compNavLinks
          .map(getLinkProps)
          .filter(link => !(isRestrictedPath(link.props.to.path) && !userLoggedIn()));
      },
      liveMatchesCount() {
        return Object.values(this.liveMatches).reduce((sum, ls) => sum += Object.keys(ls).length, 0);
      },
    },
    created() {
      this.oddFormat = localStorage.getItem('oddFormat') || APP_SETTINGS.formatting.defaultOutcomeType;
      // this.clock = setInterval(() => {
      //   this.now = new Date();
      // }, 60000);
      // this.selectedTimezone = localStorage.getItem('timezone') || '0';
      this.checkRoute(this.$router.currentRoute);
      LiveWorker.postMessage({ ev: 'liveall', resp: {} });
      LiveWorker.addEventListener('message', this.countLiveMatches);
      
    },
    methods: {
      selectOddFormat(event) {
        localStorage.setItem('oddFormat', event.target.value);
        EventBus.$emit('oddFormat', event.target.value);
      },
      // printDigits(timeValue) {
      //   if (timeValue < 10) {
      //     return `0${timeValue}`;
      //   }
      //   return String(timeValue);
      // },
      // getCurrentTime(offset) {
      //   let timestamp = this.now;
      //   if (offset) {
      //     timestamp = new Date(this.now);
      //     timestamp.setTime(timestamp.getTime() + (offset * (60 * 60 * 1000)));
      //   }
      //   let p = this.printDigits;
      //   let offsetInfo;
      //   if (!offset) {
      //     offsetInfo = '(local)';
      //   } else if (offset < 0) {
      //     offsetInfo = `(${offset})`;
      //   } else {
      //     offsetInfo = `(+${offset})`;
      //   }

      //   return `${p(timestamp.getHours())}:${p(timestamp.getMinutes())}
      //           ${offsetInfo}`;
      // },
      // selectTimezone(event) {
      //   localStorage.setItem('timezone', event.target.value);
      // },
      /**
       * Prevent rerouting on event-view
       */
      checkRoute(route) {
        this.selectedLinkIndex = this.compNavLinks.findIndex(link => {
          if (route.path.includes('event-view')) {
            return link.link.includes('event-view');
          }
          const base = this.$router.history.base;
          if (this.$router.mode !== 'hash') {
            if (this.$router.mode === 'history') {
              return link.link.replace('#', '') === route.path;
            }
            return link.link.replace(base, '') === route.path;
          }
          return link.link.replace('#', '') === route.path;
        });
      },
      countLiveMatches(msg) {
        if (msg.data.type === 'liveall') {
          this.liveMatches = msg.data.data.lm;
        }
      },
    },
    watch: {
      '$route': function (to) {
        this.checkRoute(to);
      },
    },
    beforeDestroy() {
      // clearInterval(this.clock);
      LiveWorker.removeEventListener('message', this.countLiveMatches);
    },
  };
</script>
